import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useCallback } from 'react';
import { useWakeLock } from '../hooks/useWakeLock';
import { useRecipeTimer } from '../hooks/useRecipeTimer';
import { StepDisplay } from './StepDisplay';
import { StepIndicator } from './StepIndicator';
export function CookingModeView({ recipe, onExit }) {
    const [currentStep, setCurrentStep] = useState(0);
    const { requestWakeLock, releaseWakeLock } = useWakeLock();
    const handleTimerComplete = useCallback(() => {
        // Play alarm sound or vibrate
        if ('vibrate' in navigator) {
            navigator.vibrate([200, 100, 200, 100, 200]);
        }
    }, []);
    const timer = useRecipeTimer(handleTimerComplete);
    useEffect(() => {
        requestWakeLock();
        return () => {
            releaseWakeLock();
        };
    }, [requestWakeLock, releaseWakeLock]);
    // Keyboard navigation
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'ArrowLeft' && currentStep > 0) {
                setCurrentStep((s) => s - 1);
            }
            else if (e.key === 'ArrowRight' && currentStep < recipe.steps.length - 1) {
                setCurrentStep((s) => s + 1);
            }
            else if (e.key === 'Escape') {
                onExit();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [currentStep, recipe.steps.length, onExit]);
    const step = recipe.steps[currentStep];
    const canGoBack = currentStep > 0;
    const canGoForward = currentStep < recipe.steps.length - 1;
    return (_jsxs("div", { className: "fixed inset-0 bg-gray-900 flex flex-col z-50", children: [_jsxs("header", { className: "flex items-center justify-between px-6 py-4 border-b border-gray-700", children: [_jsx("button", { onClick: onExit, className: "text-gray-400 hover:text-white transition-colors text-lg", children: "Exit" }), _jsxs("span", { className: "text-gray-400 text-lg", children: ["Step ", currentStep + 1, " of ", recipe.steps.length] })] }), _jsx("main", { className: "flex-1 flex flex-col overflow-hidden", children: _jsx(StepDisplay, { step: step, stepNumber: currentStep + 1, timer: timer }) }), _jsxs("footer", { className: "px-6 py-6 border-t border-gray-700", children: [_jsx(StepIndicator, { current: currentStep, total: recipe.steps.length }), _jsxs("nav", { className: "flex justify-between mt-6", children: [_jsx("button", { disabled: !canGoBack, onClick: () => setCurrentStep((s) => s - 1), className: `px-8 py-4 rounded-lg text-lg font-medium transition-colors ${canGoBack
                                    ? 'bg-gray-700 hover:bg-gray-600 text-white'
                                    : 'bg-gray-800 text-gray-600 cursor-not-allowed'}`, children: "Previous" }), _jsx("button", { disabled: !canGoForward, onClick: () => setCurrentStep((s) => s + 1), className: `px-8 py-4 rounded-lg text-lg font-medium transition-colors ${canGoForward
                                    ? 'bg-blue-600 hover:bg-blue-700 text-white'
                                    : 'bg-gray-800 text-gray-600 cursor-not-allowed'}`, children: "Next" })] })] })] }));
}
